export const placeData = {
	title: "Informations de contrat",
	description: "Informations générales du compte",
	loading: "Chargement...",
	accessDenied: {
		title: "Accès Refusé",
		description: "Vous n'avez pas l'autorisation d'accéder à cet écran.",
	},
	error: {
		title: "Erreur",
		description:
			"Une erreur s'est produite lors du chargement des données. Veuillez réessayer.",
	},
	sections: {
		general: {
			title: "Général",
			description: "Informations générales du compte",
		},
		fees: {
			title: "Frais",
			description:
				"Valeurs représentent les frais qui seront appliqués aux éléments ci-dessous",
		},
		balanceModel: {
			title: "Modèle de solde",
			description: "Définition du retour de solde",
		},
		grabAndGo: {
			title: "Grab and Go",
			description: "Type de livraison configuré",
		},
		eventCurrency: {
			title: "Devise de l'événement",
			description: "Devise et proportion utilisée",
		},
		smartPosSettings: {
			title: "Paramètres SmartPOS",
			description: "Données d'intégration",
		},
		communication: {
			title: "Communication",
			description: "Envoi de messages (SMS et WhatsApp)",
		},
	},
	fields: {
		contractNumber: "Numéro de contrat",
		profile: "Profil",
		mainVersion: "Version principale",
		guaranteedMonthlyMinimum: "Minimum mensuel garanti",
		monthlyBillingCap: "Plafond mensuel de facturation",
		zigResponsible: "Responsable ZIG",
		placeStatus: "Statut du local",
		zigLocation: "Emplacement Zig",
		ppuAuthorizationValue: "Valeur de la préautorisation de l’application",
		rechargeNotIntegratedLimit: "Limite de recharge non intégrée",
		localResponsible: "Responsable(s) du local",
		minVersion: "Version minimale du PDV",
		placeClassification: "Classification du local",
		smsNumbers: "Numéros pour l'envoi de SMS de revenus",
		serviceFee: "Frais de service",
		deliveryFee: "Frais de livraison",
		onlineDeliveryFee: "Frais de livraison en ligne",
		advanceReservationFee: "Frais de facturation anticipée pour les réservations",
		processingFee: "Frais de traitement",
		platformFee: "Frais de plateforme",
		house: "Maison",
		status: {
			active: "Actif",
			blocked: "Bloqué",
			inactive: "Inactif",
			paused: "En pause",
		},
		profileValues: {
			barAndRestaurant: "Bar et Restaurant",
			restaurant: "Restaurant",
			concertHall: "Salle de Concerts",
			bar: "Bar",
			nightclub: 'Boîte de Nuit"',
			park: "Parc",
			sportsArena: "Arène Sportive",
			other: "Autre",
		},
		parentPlaceName: "Lieu Parent",
		nonIntegratedPaymentLimit: "Limite de paiement non intégré par appareil et événement",
		balanceReturnType: "Type de retour de solde",
		returnPeriod: "Période de retour",
		minimumBalance: "Solde minimum",
		maximumBalance: "Solde maximum",
		deliveryType: "Type de livraison",
		deliveryTime: "Temps de livraison",
		deliveryRadius: "Rayon de livraison",
		deliveryTypes: {
			counterDelivery: "Livraison au comptoir",
			tableDelivery: "Livraison à table",
		},
		deliveryPlatforms: {
			ifood: {
				brandName: "IFood",
				settlementDays: "Jours jusqu'à la liquidation d' IFood",
				fee: "Frais iFood",
				description: "Paramètres IFood",
			},
		},
		currency: "Nom",
		exchangeRate: "Proportion à la monnaie du pays",
		currencySymbol: "Symbole",
		decimalPlaces: "Places décimales",
		integrationStatus: "Statut d'intégration",
		apiVersion: "Version API",
		lastSync: "Dernière synchronisation",
		syncFrequency: "Fréquence de synchronisation",
		smsCost: "Coût de l’envoi",
		whatsappCost: "Coût de l’envoi",
		whatsappEnabled: "WhatsApp activé",
		whatsappId: "ID du service",
		pushNotifications: "Notifications push",
		placeType: "Type de Place",
		placeTypesValues: {
			default: "Par défaut",
			delivery: "Livraison",
			transfers: "Transferts",
			advance: "Avance",
			billing: "Facturation",
		},
		delveryOnlineRules: "Règles de livraison en ligne",

		zigFeeShouldBeChargedInDebit: "Facturer les frais Zig à la date de débit",
		hasCustomizedCard: "Le dépôt de garantie appartient au client",
		user: "Utilisateur",
		fiscalPrinters: "Imprimantes fiscales",
		name: "Imprimantes",
		bankAccountData: "Données de compte bancaire",
		receivingAccount: "Compte de réception",
		accountHolder: "Titulaire du compte",
		documentType: "Type de document",
		digit: "Chiffre",
		accountIdentification: "Identification du compte",
		accountIdentifier: "Identifiant du compte",
		cpfCnpj: "CPF/CNPJ",
		accountType: "Type de compte",
		accountTypes: {
			conta_corrente: "Courant",
			conta_poupanca: "Épargne",
			conta_salario: "Salaire",
		},
		registrationData: "Données à enregistrer",
		bankData: "Données bancaires",
		branch: "Agence",
		bank: "Banque",
		bankName: "Nom de la banque",
		account: "Compte",
		recharges: "Recharges",
		rechargeValidityCriteria: "Validité et critères de recharge",
		rechargesExpireIn: "Les recharges expirent dans",
		remainingRechargeActions: "Actions pour le solde de recharge",
		whatsappNumber: "Numéro",
		chargeBack: "Expirer à la fin de l'événement",
		placeOnly: "Gérées par la maison",
		normal: "Gérées par Zig",
		// Tarifs et valeurs
		rateType: "Type",
		rateTypeLabel: "Type de tarif",
		singleRate: "Tarif unique",
		segmentedFeeType: "Tarif segmenté",
		singleFeeType: "Tarif unique",
		systemFee: "Tarif du système",
		inHouseConsumption: "Consommation sur place",
		ticketOfficeRevenue: "Revenus de billetterie",
		rechargeSurplus: "Excédent de recharge",
		bonus: "Bonus",
		fixedFee: "Tarif fixe",
		appFee: "Tarif sur app",
		prechargeOnlinePaymentFee: "Tarif de pré-charge/paiement en ligne",
		fixedFeePaymentDay: "Jour de paiement du tarif fixe",
		anticipationFee: "Tarif d'anticipation",
		thirdPartyPaymentFee: "Tarif de paiement tiers",
		// Paiement avec machine ZigPay
		zigPayMachinePayment: "Paiement avec machine ZigPay",
		debit: "Débit",
		credit: "Crédit",
		creditOtherFlags: "Crédit (Autres drapeaux)",
		debitOtherFlags: "Débit (Autres drapeaux)",
		replicateRatesForAllFlags: "Répliquer les tarifs pour tous les drapeaux ?",
		pix: "Pix",
		pixKey: "Clé Pix",
		pixKeyType: "Type de Clé PIX",
		yes: "Oui",
		// Ticket restaurant
		foodVoucher: "Ticket restaurant",
		// Paiement avec machine intégrée dans l'EC du client
		integratedMachinePayment: "Paiement avec machine intégrée dans l'EC du client",
		machineCommission: "Commission des machines",
		anticipatedConsumption: "Consommation anticipée",
		anticipatedBar: "Anticipé/Bar",
		ticketOffice: "Billetterie",
		// Jours jusqu'à la collecte
		daysUntilCollection: "Jours jusqu'à la collecte",
		daysUntilCollectionDescription:
			"Nombre de jours pour exercer la collecte et les paiements dans les formats suivants",
		collectionDaysDescription:
			"Nombre de jours pour exercer la collecte et les paiements dans les formats suivants",
		// Échelonnement
		installment: "Échelonnement",
		installmentFee: "Tarif d'échelonnement",
		maxInstallments: "Nombre max. d'échéances",
		notApplicable: "Non applicable",
	},
};
